import React, { useState } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/core';
import { Modals } from '../../../constants/ScreenNames';
import { Color, CommonStyles } from '../../../styles';
import DescriptionWidget from '../../TripEvents/DescriptionWidget';
import { useSelector } from 'react-redux';
import {
  selectUserProfile,
  selectUserProfileImage,
} from '../../../store/selectors/profile.selector';
import WrapBottomColor from '../../containers/WrapBottomColor';
import BottomButton from '../../BottomButton';
import useFormList from '../../../utils/useFormList';
import MeetingSection from '../../event/MeetingSection';
import SpeakerSection from '../../event/SpeakerSection';
import { createEmptyMeeting, createEmptySpeaker } from '../../../utils/event.utils';

const EventSettings = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { event, disableDescription, disableMeetings, disableSpeakers } = route?.params || {};
  const [description, setDescription] = useState('');
  const {
    list: meetings,
    add: addMeeting,
    remove: removeMeeting,
    update: updateMeeting,
  } = useFormList(createEmptyMeeting, event?.hasMeeting);
  const {
    list: speakers,
    add: addSpeaker,
    remove: removeSpeaker,
    update: updateSpeaker,
  } = useFormList(createEmptySpeaker, event?.hasSpeaker);
  const userProfile = useSelector(selectUserProfile);
  const userImage = useSelector(selectUserProfileImage);

  const user = {
    name: `${userProfile.FirstName} ${userProfile.LastName}`,
    url: userImage,
  };
  const onSubmit = () => {
    navigation.navigate(Modals.EventPreviewModal, {
      event,
      description,
      meetings,
      speakers,
      user,
    });
  };

  return (
    <>
      <ScrollView style={[CommonStyles.px4, CommonStyles.pt4, CommonStyles.pb5]}>
        {!disableDescription ? (
          <DescriptionWidget
            style={CommonStyles.mb5}
            description={description}
            onUpdate={(val) => setDescription(val)}
          />
        ) : null}
        {!disableMeetings ? (
          <MeetingSection
            list={meetings}
            onAdd={addMeeting}
            onRemove={removeMeeting}
            onUpdate={updateMeeting}
          />
        ) : null}
        {!disableSpeakers ? (
          <SpeakerSection
            list={speakers}
            onAdd={addSpeaker}
            onRemove={removeSpeaker}
            onUpdate={updateSpeaker}
          />
        ) : null}
      </ScrollView>
      <BottomButton label="Apply" labelStyle={CommonStyles.h1} full onPress={onSubmit} />
    </>
  );
};

const EventSettingsModal = () => {
  return (
    <WrapBottomColor style={styles.container}>
      <EventSettings />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.accent,
  },
});

export default EventSettingsModal;
